import { render, staticRenderFns } from "./BubblesCustomBlock.vue?vue&type=template&id=c3d91b82"
import script from "./BubblesCustomBlock.vue?vue&type=script&lang=js"
export * from "./BubblesCustomBlock.vue?vue&type=script&lang=js"
import style0 from "./BubblesCustomBlock.vue?vue&type=style&index=0&id=c3d91b82&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports